import React from 'react';

function buildLocationDetails(geolocation){
    const locationDetails = [];
    if(geolocation["city"]){
        locationDetails.push(geolocation["city"]);
    }
    if(geolocation["region"]){
        locationDetails.push(geolocation["region"]);
    }
    if(geolocation["country"]){
        locationDetails.push(geolocation["country"]);
    }
    if(geolocation["ip"]){
        locationDetails.push(" (" + geolocation["ip"] + ")");
    }
    return locationDetails.join(", ");
}

export default function EmailRoutingPathListItem(props) {
    const { label, geolocation } = props;
    return (
        <li className="list-group-item px-0">
            <span className='font-weight-bold'>{label}: </span>
            <span>{buildLocationDetails(geolocation)}</span>
        </li>
    );
}